import { render, staticRenderFns } from "./ViewerCharsetPictogram.vue?vue&type=template&id=2b9ec576&scoped=true"
import script from "./ViewerCharsetPictogram.vue?vue&type=script&lang=js"
export * from "./ViewerCharsetPictogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9ec576",
  null
  
)

export default component.exports